import api from './loginService'
import JwtService from '@/common/jwt.service'

let setAdminSeq = ({commit}, data) => {
  commit('changeAdminSeq', data)
}

let setEmail = ({commit}, data) => {
  commit('changeEmail', data)
}

let setLevel = ({commit}, data) => {
  commit('changeLevel', data)
}

let setErrorState = ({commit}, data) => {
  commit('changeState', data)
}

let setToken = ({commit}, data) => {
  commit('changeToken', data)
}

let setIsAuth = ({commit}, data) => {
  commit('changeAuth', data)
}

// 백엔드에서 반환한 결과값을 가지고 로그인 성공 실패 여부를 vuex에 넣어준다.
let processResponse = (store, loginResponse) => {

  switch (loginResponse) {
    case 'noAuth':
      setErrorState(store, 'Wrong ID or Password')
      setIsAuth(store, false)
      break
    case 'done':
      setErrorState(store, 'No period')
      setIsAuth(store, false)
      break
    default:
      let data = loginResponse.data.data;
      setAdminSeq(store, data.adminSeq)
      setEmail(store, data.email)
      setLevel(store, data.level)
      setToken(store, data.token)
      setErrorState(store, '')
      setIsAuth(store, true)

      JwtService.saveToken(data.token)
      break
  }
}

export default {
  async login (store, {email, password}) {
    let loginResponse = await api.login(email, password)
    processResponse(store, loginResponse)
    return store.getters.getAuth  // 로그인 결과를 리턴한다
  },
  async getInfo (store, {key}) {
    return JwtService.getInfo(key)
  },
  async saveInfo (store, {key,value}){
    JwtService.saveInfo(key,value)
  }
}



// WEBPACK FOOTER //
// ./src/service/actions.js